import { ToastContainer } from "react-toastify";
import Nav from "./Nav";

const Layout = (props) => {
    return (
        <div className="app__inner">
            <Nav />
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            <main role="main" className="container my-5 pt-5">
                {props.children}
            </main>
        </div>
    );
};

export default Layout;
